// removed by extract-text-webpack-plugin
module.exports = {"section--active":"nrk-filmavis-snap-section--active","sectionActive":"nrk-filmavis-snap-section--active","animate-pulsate":"nrk-filmavis-snap-animate-pulsate","animatePulsate":"nrk-filmavis-snap-animate-pulsate","pulsateAndRotate":"nrk-filmavis-snap-pulsateAndRotate"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/animations.css
// module id = 61
// module chunks = 0